import { render } from "./Itemedit4billbord.vue?vue&type=template&id=d848ab5a&scoped=true&ts=true"
import script from "./Itemedit4billbord.vue?vue&type=script&lang=ts"
export * from "./Itemedit4billbord.vue?vue&type=script&lang=ts"

import "./Itemedit4billbord.vue?vue&type=style&index=0&id=d848ab5a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d848ab5a"]])

export default __exports__